<template>
  <div class="current-commissions">
    <div class="table-responsive">
      <table class="table table-bordered mb-0">
        <thead>
          <tr class="bg-white">
            <th scope="col">User</th>
            <th scope="col">Month</th>
            <th scope="col">Tuition</th>
            <th scope="col">Commission</th>
            <th scope="col" class="text-nowrap">Qty</th>
            <th scope="col" class="text-nowrap">Key Partner</th>
            <th scope="col">Ref/Hunter</th>
            <th scope="col">Status</th>
            <th scope="col">Total</th>
            <th v-if="hasPendingCommission" scope="col" class="bg-white border-top-0 border-right-0"></th>
          </tr>
        </thead>
        <tbody v-if="commissionData.length > 0">
          <tr v-for="(commission, index) in commissions" :key="index">
            <td class="text-nowrap">{{ commission.user.name }}</td>
            <td>{{ formattedPeriod(commission.month,commission.year) }}</td>
            <td>{{ formattedNumbers(commission.tuition_fee) }}</td>
            <td>{{ formattedNumbers(commission.amount) }}</td>
            <td>{{ getQtyPercentage(commission.qty_percentage) }}</td>
            <td>{{ getEnhancerPercentage(commission.enhancers, ['key_partner', 'level']) }}</td>
            <td>{{ getEnhancerPercentage(commission.enhancers, ['referer', 'hunter', 'self']) }}</td>
            <td class="text-nowrap">{{ transformedText(commission.status) }}</td>
            <td class="text-right">{{ formattedNumbers(commission.amount_paid) }}</td>
            <td v-if="commission.status === 'pending'" class="text-center">
              <button @click="deleteCommission(commission.id)" class="btn btn-danger btn-sm">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="9" class="text-center">
              No commission found
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <current-commission-transactions :commission-id="commissionId" :com-transactions="transactions" />
  </div>
</template>

<script>
import { formatCurrency, formatPeriod, transformText } from "../../../utils/helpers";
import { deleteCommission } from "../../../services/api/commissions";
import CurrentCommissionTransactions from "./CurrentCommissionTransactions.vue";

export default {
  name: 'CurrentCommissionsTable',
  components: {CurrentCommissionTransactions},
  props: {
    commissions: {
      type: [Array, Object],
      default: () => []
    }
  },
  data() {
    return {
      commissionId: 0,
      commissionData: this.commissions,
      transactions: []
    }
  },
  mounted() {
    this.getCommissionTransactions()
  },
  computed: {
    hasPendingCommission() {
      return this.commissionData.some(commission => commission.status === 'pending');
    }
  },
  methods: {
    formattedPeriod(month, year, mode = false, uppercase = false) {
      return formatPeriod(month, year, mode, uppercase);
    },
    formattedNumbers(number) {
      return formatCurrency(number);
    },
    transformedText(text) {
      return transformText(text);
    },
    getQtyPercentage(student_qty) {
      return student_qty ? `${student_qty}%` : '-';
    },
    getEnhancerPercentage(enhancers, types) {
      if(enhancers){
        const enhancer = enhancers.find(enh => types.includes(enh.type));
        return enhancer ? `${enhancer.percentage}%` : '-';
      }else {
        return '-';
      }
    },
    getTotal(metric, statuses = []) {
      return this.commissionData.reduce((sum, commission) => {
        if (statuses.length === 0 || statuses.includes(commission.status)) {
          return sum + (parseFloat(commission[metric]) || 0);
        }
        return sum;
      }, 0).toFixed(2);
    },
    getCommissionTransactions() {
      const commissions = this.commissionData;

      this.commissionId = commissions.length > 0 ? commissions[0].id : null;
      this.transactions = commissions.flatMap(commission => commission.transactions || []);
    },
    async deleteCommission(commission_id) {
      if (confirm('Are you sure you want to delete this commission?')) {
        try {
          const response = await deleteCommission(commission_id);

          if (response.status === 200) {
            this.commissionData = this.commissionData.filter(commission => commission.id !== commission_id);

            new Noty({
              type: "success",
              text: 'Commission removed successfully',
            }).show();
          } else {
            new Noty({
              type: "error",
              text: 'Failed to remove the commission. Please try again later.',
            }).show();
          }
        } catch (error) {
          console.error('Error deleting commission:', error);

          new Noty({
            type: "error",
            text: 'Failed to remove the commission. Please try again later.',
          }).show();
        }
      }
    }
  }
}
</script>